// libraries
import React from "react";

// styles
import styles from "./styles.module.scss";

// helpers
import { convertToSlug, handleFileInput } from "../../../utils/helpers";

// assets
import image from "../../../assets/images/create-event/image.svg";
import video from "../../../assets/images/create-event/video.svg";

const Media = ({ formData, setFormData }) => {
  return (
    <div className={styles.media}>
      <div className={styles.img_wrap}>
        {formData.eventFile ? (
          formData.eventFile.object.type.includes("image") ? (
            <label className={styles.main_img}>
              <img src={formData.eventFile.url} alt="event" />
              <input
                type="file"
                accept="image/*, video/*"
                onChange={(e) => {
                  setFormData({
                    ...formData,
                    eventFile: handleFileInput(e.target.files),
                  });
                }}
              />
            </label>
          ) : (
            <label
              className={styles.main_img}
              onClick={(e) => e.stopPropagation()}
            >
              <video autoPlay>
                <source src={formData.eventFile.url} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
              <input
                type="file"
                accept="image/*, video/*"
                onChange={(e) => {
                  setFormData({
                    ...formData,
                    eventFile: handleFileInput(e.target.files),
                  });
                }}
              />
            </label>
          )
        ) : (
          <div>
            <label>
              <img src={image} alt="add" />
              <input
                type="file"
                accept="image/*"
                onChange={(e) => {
                  setFormData({
                    ...formData,
                    eventFile: handleFileInput(e.target.files),
                  });
                }}
              />
              Add Photo
            </label>
            {/* <label>
              <img src={video} alt='add' />
              <input
                type='file'
                accept='video/*'
                onChange={(e) => setFile(handleFileInput(e.target.files))}
              />
              Add Video
            </label> */}
          </div>
        )}
      </div>
      <label className={styles.event_name}>
        Event Name
        <input
          placeholder="Name of event"
          value={formData.eventName}
          onChange={(e) =>
            setFormData({ ...formData, eventName: e.target.value })
          }
        />
      </label>
      <div className={styles.url}>
        <p>This will be your URL</p>
        <h6
          onClick={() => {
            // navigator.clipboard.writeText("https:google.com");
          }}
        >
          eventmoon/{convertToSlug(formData.eventName)}
        </h6>
      </div>
      <textarea
        value={formData.eventDescription}
        onChange={(e) =>
          setFormData({ ...formData, eventDescription: e.target.value })
        }
        placeholder="Describe your Event the best way possible!"
      ></textarea>
    </div>
  );
};

export default Media;
